import React from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import Helmet from 'react-helmet'

import Footer from './components/footer/Footer'
import Header from './components/header/Header'
import PageTemplate from './components/body/PageTemplate'
import RitTemplate from './components/body/RitTemplate'
import aroData from './data/aroQuestions'
import gasbData from './data/gasbQuestions'
import sbitaData from './data/sbitaQuestions'
import ritData from './data/ritQuestions'
import sendEmail from './submit-hubspot/sendEmail'
import aroQualifiedEmail from './email-templates/aroQualifiedEmail.js'
import aroUnqualifiedEmail from './email-templates/aroUnqualifiedEmail.js'
import gasbQualifiedEmail from './email-templates/gasbQualifiedEmail'
import gasbUnqualifiedEmail from './email-templates/gasbUnqualifiedEmail'
import sbitaQualifiedEmail from './email-templates/sbitaQualifiedEmail'
import sbitaUnqualifiedEmail from './email-templates/sbitaUnqualifiedEmail'
import ritEmail from './email-templates/ritEmail.js'
import { PaymentProvider } from './context/PaymentContext'
import { JurisdictionProvider } from './context/JurisdictionContext'

import './styles/main.css'

function App() {
	const aroPageTitle = 'Asset Retirement Obligation Identifier'
	const gasbPageTitle = 'GASB 87 Lease Identifier'
	const sbitaPageTitle = 'GASB 96: Subscription-Based IT Arrangement Identifier'
	const ritPageTitle = 'Rate Implicit Calculator'
	const windowGlobal = typeof window !== 'undefined' && window

	let aroQuestionData = aroData
	let gasbQuestionData = gasbData
	let sbitaQuestionData = sbitaData
	let ritQuestionData = ritData
	let identifierType,
		title = 'LeaseQuery Free Tool',
		setPath,
		setQuestions = {},
		setQualifiedEmail,
		setUnqualifiedEmail,
		subject,
		numOfAnswers

	if (
		typeof window !== 'undefined' &&
		typeof sessionStorage !== 'undefined' &&
		sessionStorage.getItem('gasb-questions')
	) {
		gasbQuestionData = JSON.parse(
			windowGlobal.sessionStorage.getItem('gasb-questions')
		)
	}

	if (
		typeof window !== 'undefined' &&
		typeof sessionStorage !== 'undefined' &&
		sessionStorage.getItem('sbita-questions')
	) {
		sbitaQuestionData = JSON.parse(
			windowGlobal.sessionStorage.getItem('sbita-questions')
		)
	}

	if (
		typeof window !== 'undefined' &&
		typeof sessionStorage !== 'undefined' &&
		sessionStorage.getItem('aro-questions')
	) {
		aroQuestionData = JSON.parse(
			windowGlobal.sessionStorage.getItem('aro-questions')
		)
	}

	if (
		typeof window !== 'undefined' &&
		typeof sessionStorage !== 'undefined' &&
		sessionStorage.getItem('rit-questions')
	) {
		ritQuestionData = JSON.parse(
			windowGlobal.sessionStorage.getItem('rit-questions')
		)
	}

	const [aroQuestions, setAroResponse] = React.useState(aroQuestionData)
	const [gasbQuestions, setGasbResponse] = React.useState(gasbQuestionData)
	const [sbitaQuestions, setSbitaResponse] = React.useState(sbitaQuestionData)
	const [ritQuestions, setRitResponse] = React.useState(ritQuestionData)

	if (window.location.href.indexOf('/aro-identifier') > -1) {
		identifierType = 'aro'
		title = aroPageTitle
		setPath = '/aro-identifier'
		setQuestions = aroQuestions
		setQualifiedEmail = aroQualifiedEmail
		setUnqualifiedEmail = aroUnqualifiedEmail
		subject = `Asset Retirement Obligation Identifier Results for`
	} else if (window.location.href.indexOf('/gasb-87-lease-identifier') > -1) {
		identifierType = 'gasb'
		title = gasbPageTitle
		setPath = '/gasb-87-lease-identifier'
		setQuestions = gasbQuestions
		setQualifiedEmail = gasbQualifiedEmail
		setUnqualifiedEmail = gasbUnqualifiedEmail
		subject = `GASB 87 Lease Identifier Results for`
	} else if (window.location.href.indexOf('/gasb-96-SBITA-identifier') > -1) {
		identifierType = 'sbita'
		title = sbitaPageTitle
		setPath = '/gasb-96-SBITA-identifier'
		setQuestions = sbitaQuestions
		setQualifiedEmail = sbitaQualifiedEmail
		setUnqualifiedEmail = sbitaUnqualifiedEmail
		subject = `GASB 96 SBITA Identifier Results for`
	} else if (window.location.href.indexOf('/rate-implicit-calculator') > -1) {
		identifierType = 'rit'
		title = ritPageTitle
		setQuestions = ritQuestions
		setQualifiedEmail = ritEmail
		subject = `Rate Implicit Calculator Results for`
	}

	React.useEffect(() => {
		sessionStorage.setItem('aro-questions', JSON.stringify(aroQuestions))
		sessionStorage.setItem('gasb-questions', JSON.stringify(gasbQuestions))
		sessionStorage.setItem('sbita-questions', JSON.stringify(sbitaQuestions))
		sessionStorage.setItem('rit-questions', JSON.stringify(ritQuestions))
	}, [aroQuestions, gasbQuestions, sbitaQuestions, ritQuestions])

	function updateQuestions(prompt, response, subResponse = '') {
		try {
			let questions = { ...setQuestions }
			let question = { ...questions[prompt] }

			if (subResponse) {
				question.answer = response
				question.subAnswer = subResponse
			} else {
				question.answer = response
			}

			questions[prompt] = question

			switch (identifierType) {
				case 'aro':
					setAroResponse(questions)
					break
				case 'gasb':
					setGasbResponse(questions)
					break
				case 'sbita':
					setSbitaResponse(questions)
					break
				case 'rit':
					setRitResponse(questions)
					break
				default:
					break
			}
		} catch (ex) {
			console.log('exception', ex)
		}
	}

	function setSessionData() {
		window.onbeforeunload = function () {
			sessionStorage.setItem('origin', window.location.href)
		}

		window.onload = function () {
			try {
				const urlOrigin = sessionStorage.getItem('origin')
					? sessionStorage.getItem('origin').toString().toLowerCase()
					: ''

				if (
					urlOrigin &&
					!sessionStorage.getItem('formActive') &&
					window.location.href.toLowerCase() === urlOrigin
				) {
					sessionStorage.clear()
				}
			} catch (ex) {}
		}
	}

	function submitToHubSpot(redirectUri, email, firstName) {
		let result

		if (
			setQuestions[Object.keys(setQuestions).length - 1].answer &&
			setQuestions[Object.keys(setQuestions).length - 1].answer === 'Yes'
		) {
			result = setQualifiedEmail
		} else {
			result = setUnqualifiedEmail
		}

		const data = {
			Email: {
				ToAddressList: [email],
				Subject: `${subject} ${firstName}`,
				BodyHtml: result,
			},
		}

		sendEmail(data).then((res) => {
			window.location.href = redirectUri
		})
	}

	function submitRitToHubSpot(
		redirectUri,
		email,
		firstName,
		leaseName,
		startDate,
		endDate,
		fairValue,
		expectedResidualValue,
		rateData,
		payments
	) {
		let result = setQualifiedEmail(
			leaseName,
			startDate,
			endDate,
			fairValue,
			expectedResidualValue,
			rateData,
			payments
		)

		const data = {
			Email: {
				ToAddressList: [email],
				Subject: `${subject} ${firstName}`,
				BodyHtml: result,
			},
		}

		sendEmail(data).then((res) => {
			window.location.href = redirectUri
		})
	}

	switch (identifierType) {
		case 'aro':
			numOfAnswers = Object.keys(aroQuestions).filter((key, index) => {
				return aroQuestions[key].answer
			}).length
			break
		case 'gasb':
			numOfAnswers = Object.keys(gasbQuestions).filter((key, index) => {
				return gasbQuestions[key].answer
			}).length
			break
		case 'sbita':
			numOfAnswers = Object.keys(sbitaQuestions).filter((key, index) => {
				return sbitaQuestions[key].answer
			}).length
			break
		case 'rit':
			numOfAnswers = Object.keys(ritQuestions).filter((key, index) => {
				return ritQuestions[key].answer
			}).length
			break
		default:
			break
	}

	setSessionData()

	return (
		<div className='page-wrapper'>
			<Helmet>
				<meta name='og:title' content={title} />
				<meta name='og:description' content={title} />
				<meta name='title' content={title} property='og:title' />
				<meta name='description' content={title} property='og:description' />
				<title>{title}</title>
			</Helmet>

			<Header title={title} />
			<hr />
			<Router>
				<PaymentProvider>
					<JurisdictionProvider>
						{/* initial RIT question prompt */}
						<Route
							exact
							path={[
								'/rate-implicit-calculator',
								`/rate-implicit-calculator.html`,
							]}
							key={1}
							component={() => (
								<RitTemplate
									formData={setQuestions[1]}
									submitAnswer={updateQuestions}
									title={title}
								/>
							)}
						/>

						{/* remaining RIT question prompt */}
						{Object.keys(setQuestions).map((key, index) => {
							return (
								<Route
									exact
									path={`/rate-implicit-calculator/prompt/${index + 1}`}
									key={index}
									component={() => (
										<RitTemplate
											formData={setQuestions[key]}
											submitAnswer={updateQuestions}
											title={title}
										/>
									)}
								/>
							)
						})}

						{/* submit RIT form prompt if there are answers, prevent user from going straight to submit */}
						<Route
							exact
							path={`/rate-implicit-calculator/submit`}
							component={() => {
								if (
									numOfAnswers > 0 &&
									window.location.href.indexOf('/submit') > -1
								) {
									return (
										<RitTemplate
											formData={setQuestions.submit}
											submitForm={submitRitToHubSpot}
											title={title}
										/>
									)
								} else {
									window.location.href = `${window.location.origin}/rate-implicit-calculator`
								}
							}}
						/>
					</JurisdictionProvider>
				</PaymentProvider>
				{/* initial question prompt */}
				<Route
					exact
					path={[setPath, `${setPath}.html`]}
					key={0}
					component={() => (
						<PageTemplate
							formData={setQuestions[1]}
							submitAnswer={updateQuestions}
							title={title}
						/>
					)}
				/>

				{/* remaining question prompt */}
				{Object.keys(setQuestions).map((key, index) => {
					return (
						<Route
							exact
							path={`${setPath}/prompt/${index + 1}`}
							key={index}
							component={() => (
								<PageTemplate
									formData={setQuestions[key]}
									submitAnswer={updateQuestions}
									title={title}
								/>
							)}
						/>
					)
				})}

				{/* submit form prompt if there are answers, prevent user from going straight to submit */}
				<Route
					exact
					path={`${setPath}/submit`}
					component={() => {
						if (
							numOfAnswers > 0 &&
							window.location.href.indexOf('/submit') > -1
						) {
							return (
								<PageTemplate
									formData={setQuestions.submit}
									submitForm={submitToHubSpot}
									title={title}
								/>
							)
						} else {
							window.location.href = `${window.location.origin}${setPath}`
						}
					}}
				/>
			</Router>
			<Footer />
		</div>
	)
}

export default App
